import React, { useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import PostRequest from '../../../../service/PostRequest';
import GetRequest from '../../../../service/GetRequest';
import InputFieldIconText from '../../../../components/Widgets/Inputs/InputFieldIconText';
import InputPassword from '../../../../components/Widgets/Inputs/InputPassword';
import BOSS_mainlogo from '../../../../assets/icons/BOSS_mainlogo.svg';
import "./EmailRegistration.scss";

const RegistrationForm = ({ plan }) => {
    const navigate = useNavigate();
    const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
    const toastBottomCenter = useRef(null);

    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [fullNameError, setFullNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [existingUserMessage, setExistingUserMessage] = useState("");

    const showMessage = (message, ref, severity) => {
        ref.current.show({ severity: severity, summary: message, detail: message, life: 3000 });
    };
    const handleExistingEmailCheck = async () => {
        setIsWaitingForResponse(true);
        await GetRequest(`auth/validate/email?email=${email}`)
           .then(response => {
                if (response.data) {
                    setExistingUserMessage("Email already exists");
                } else {
                    setExistingUserMessage("");
                }
                setIsWaitingForResponse(false);
            })
           .catch(error => {
                console.error(error);
                setExistingUserMessage("An error occurred while checking email");
                setIsWaitingForResponse(false);
            });
    }
    const validateInputs = async () => {
        setFullNameError("");
        setEmailError("");
        setPasswordError("");
        setConfirmPasswordError("");

        let isValid = true;

        const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (!email.trim()) {
            setEmailError("Email is required");
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            setEmailError("Invalid email address");
            isValid = false;
        }

        if (!fullName.trim()) {
            setFullNameError("Full Name is required");
            isValid = false;
        }

        if (!password.trim()) {
            setPasswordError("Password is required");
            isValid = false;
        } else if (!passwordRegex.test(password)) {
            setPasswordError("Password must be at least 8 characters with special character.");
            isValid = false;
        }

        if (!confirmPassword.trim()) {
            setConfirmPasswordError("Confirm Password is required");
            isValid = false;
        } else if (password !== confirmPassword) {
            setConfirmPasswordError("Passwords do not match");
            isValid = false;
        }

        if (email) {
            if(existingUserMessage.length > 0) {   
                isValid = false
            }
        
        }

        return isValid;
    };

    const completeSetup = async () => {
        const isValid = await validateInputs();

        const data = {
            fullName: fullName,
            email: email,
            password: password,
        };

        if (isValid) {
            setIsWaitingForResponse(true);
            await PostRequest(`auth/store/register?planDetails=${plan}`, data, false)
                .then(response => {
                    if (response) {
                        setIsWaitingForResponse(false);
                        navigate("/verify-email", { state: { email } });
                    } else {
                        setIsWaitingForResponse(false);
                        showMessage("Registration failed", toastBottomCenter, 'danger');
                    }
                });
        }
    };

    const handleFullNameChange = (e) => {
        setFullName(e.target.value);
        setFullNameError("");
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setEmailError("");
        setExistingUserMessage("");
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setPasswordError("");
        setConfirmPasswordError("");
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        setConfirmPasswordError("");
    };

    return (
        <div className='EmailRegisterContainer'>
            <div className='Heading'>
                <img src={BOSS_mainlogo} alt="BOSS Logo" />
                <h3>Create an account using Email</h3>
            </div>
            <div className='WholeForm'>
                <div className='NameInput'>
                    <label>Full Name</label>
                    <InputFieldIconText value={fullName} onChange={handleFullNameChange} label="Full name" errorMessage={fullNameError} inputIcon="pi pi-user" />
                </div>
                <div className='EmailInput'>
                    <label>Email</label>
                    <InputFieldIconText value={email} onChange={handleEmailChange} onBlur={handleExistingEmailCheck} label="Email" errorMessage={emailError} inputIcon="pi pi-envelope" />
                    {existingUserMessage && <p style={{color:"red"}}>{existingUserMessage}</p>}
                </div>
                <div className='PasswordInput'>
                    <label>Password</label>
                    <InputPassword value={password} label="Password" onChange={handlePasswordChange} errorMessage={passwordError} />
                </div>
                {passwordError && <small style={{color:"red",width:"300px !important"}}>{passwordError}</small>}
                <div className='PasswordInput'>
                    <label>Confirm Password</label>
                    <InputPassword value={confirmPassword} label="Confirm Password" onChange={handleConfirmPasswordChange} errorMessage={confirmPasswordError} />
                    {confirmPasswordError && <small className="p-error">{confirmPasswordError}</small>}
                </div>
                <Button label="Create An Account" severity="primary" onClick={completeSetup} style={{ width: "355px", borderRadius: "40px", marginTop: "20px" }} disabled={isWaitingForResponse} loading={isWaitingForResponse} />
                <div className='LoginText'>
                    <p>Already have an Account? Click here to <span className="text-span" onClick={() => navigate("/login")}>Login</span></p>
                </div>
            </div>
            <Toast ref={toastBottomCenter} position="bottom-center" />
        </div>
    );
};

export default RegistrationForm;
